import React from 'react';
import PropTypes from 'prop-types';
import { STATUS_CODE } from '@shared/constants';
import { isServer } from '@commons/utils';
import FeedbackPage from '@pedidosya/web-fenix/system/FeedbackPage';
import FooterButton from '@pedidosya/web-fenix/system/FooterButton';

const navigateToHome = () => {
  if (!isServer()) {
    window.location = '/';
  }
};

const reload = () => {
  if (!isServer()) {
    window.location.reload();
  }
};

function ErrorPage({ errorCode }) {
  if (errorCode === STATUS_CODE.NOT_FOUND)
    return (
      <FeedbackPage
        description="Lo sentimos, la página que buscas no existe."
        title="Página no encontrada"
        variant="error"
      >
        <FeedbackPage.FooterButton>
          <FooterButton.Button
            fullWidth
            hierarchy="primary"
            label="Ir al inicio"
            onClick={navigateToHome}
            size="large"
          />
        </FeedbackPage.FooterButton>
      </FeedbackPage>
    );

  return (
    <FeedbackPage
      description="Tuvimos un problema. Reintente nuevamente."
      title="Hubo un error"
      variant="error"
    >
      <FeedbackPage.FooterButton>
        <FooterButton.Button
          fullWidth
          hierarchy="primary"
          label="Reintentar"
          onClick={reload}
          size="large"
        />
      </FeedbackPage.FooterButton>
    </FeedbackPage>
  );
}

ErrorPage.propTypes = {
  errorCode: PropTypes.number,
};

ErrorPage.defaultProps = {
  errorCode: STATUS_CODE.INTERNAL_ERROR,
};

export default ErrorPage;
